export enum ConfirmActionType {
  Delete = 'delete',
  Save = 'save'
}
